import React, { useState, useRef } from 'react';
import { Modal, Button, InputGroup, Form } from 'react-bootstrap';

const BookmarkThisPage = ({ url, label = 'Bookmark this page', variant = 'outline-warning' }) => {
  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);
  const inputRef = useRef(null);

  const isMac = typeof navigator !== 'undefined'
    && /Mac|iPhone|iPad|iPod/.test(navigator.platform);
  const shortcut = isMac ? 'Cmd + D' : 'Ctrl + D';

  const handleCopy = async () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
        return;
      } catch (err) {
        // fall through to manual selection
      }
    }
    if (inputRef.current) {
      inputRef.current.select();
    }
  };

  const handleClose = () => {
    setShow(false);
    setCopied(false);
  };

  return (
    <>
      <Button
        variant={variant}
        onClick={() => setShow(true)}
        className="d-inline-flex align-items-center"
      >
        <i className="fa-sharp fa-regular fa-bookmark me-2" />
        {label}
      </Button>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Bookmark this page</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted mb-3">
            Save this URL so you can return any time to submit a referral.
          </p>
          <InputGroup className="mb-3">
            <Form.Control
              ref={inputRef}
              type="text"
              value={url}
              readOnly
              onClick={(e) => e.target.select()}
            />
            <Button
              variant={copied ? 'success' : 'primary'}
              onClick={handleCopy}
            >
              <i className={`fa-sharp fa-regular ${copied ? 'fa-check' : 'fa-copy'} me-2`} />
              {copied ? 'Copied' : 'Copy URL'}
            </Button>
          </InputGroup>
          <div className="alert alert-info mb-0 small">
            <strong>Tip:</strong> Press <kbd>{shortcut}</kbd> to bookmark this page in your browser.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BookmarkThisPage;
